export default "__VITE_ASSET__dd52f32b__"